import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  error: "", // for error msg
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
  user: {
    id: 0,
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    organization_id: 0,
  },
  accessToken: "",
  refreshToken: "",
  default_language: "en",
  default_currency: "USD",
  isAuthenticated: false,
  isSuperAdmin: false,
  isFirstTime: true,
  loggedInAt: "",
  permissions: {},
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    apiError(state, action) {
      state.error = action.payload;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    resetLoginFlag(state) {
      state.error = "";
      state.loading = false;
      state.errorMsg = false;
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true;
    },
    setIsAuthenticated: (state, { payload }) => {
      state.isAuthenticated = payload;
    },
    setIsFirstTime: (state, { payload }) => {
      state.isFirstTime = payload;
    },
    setUser: (state, { payload }) => {
      state.user = payload.user;
      state.permissions = payload.user_permissions;
      state.loggedInAt = String(Date.now());
      state.isAuthenticated = true;
      state.isSuperAdmin = payload?.user_role === "SuperAdmin";
    },
    setDefaults: (state, { payload }) => {
      if (payload) {
        if (payload.default_currency) {
          state.default_currency = payload.default_currency;
        }
        if (payload.default_language) {
          state.default_language = payload.default_language;
        }
      }
    },
    setToken: (state, { payload }) => {
      state.accessToken = payload.accessToken;
      state.refreshToken = payload.refreshToken;
    },
    setLogout: (state) => {
      state.accessToken = "";
      state.refreshToken = "";
      state.loggedInAt = "";
      state.default_currency = "USD";
      state.default_language = "en";
      state.isSuperAdmin = false;
      state.user = {
        id: 0,
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        organization_id: 0,
      };
      state.permissions = {};
    },
    setLoggedInAt: (state, { payload }) => {
      state.loggedInAt = payload;
    },
  },
});
export const {
  loginSuccess,
  apiError,
  resetLoginFlag,
  logoutUserSuccess,
  setIsFirstTime,
  setIsAuthenticated,
  setUser,
  setToken,
  setDefaults,
  setLogout,
  setLoggedInAt,
} = loginSlice.actions;
export default loginSlice.reducer;
